import { z } from 'zod';
import { PresetIdSchema } from './generation.js';
export const ReferenceManifestEntrySchema = z.object({
    path: z.string().min(1),
    tags: z.array(z.string()).default([]),
    description: z.string().optional(),
});
export const BrandIdentityFileSchema = z.object({
    version: z.literal(1),
    style_descriptor: z.string().max(600).default(''),
    color_palette: z.array(z.string()).max(8).default([]),
    mood_tags: z.array(z.string()).max(10).default([]),
    typography: z
        .object({
        heading: z.string().optional(),
        body: z.string().optional(),
        mono: z.string().optional(),
    })
        .optional(),
    constraints: z.array(z.string()).max(20).default([]),
    preset_routing: z
        .object({
        default_preset: PresetIdSchema.default('flat_illustration'),
    })
        .optional(),
    references: z.array(ReferenceManifestEntrySchema).default([]),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
//# sourceMappingURL=brand-identity.js.map